import React from 'react';
import { Form, Input, Typography, Card, Switch } from 'antd';
import { useCompanyStore } from '../../store/company/companyStore';
import { useApi } from '../../services/ApiContext';
import { Company } from '../../types/ffe';
const { Title, Text } = Typography;

export const PurchaseOrderSettings: React.FC = () => {

  const company = useCompanyStore((state) => state.company);
  const api = useApi()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateSettings = (values: Company['purchaseOrderSettings']) => {
    api.syncCompany({
      purchaseOrderSettings: values,
    })
  }
  
  return (
    <div className="space-y-6">
      <Card>
        <Title level={5}>Purchase Order Settings</Title>
        <Text type="secondary" className="block mb-6">
          These settings will apply for all new purchase orders generated from your projects
        </Text>

        <Form
          layout="vertical"
          initialValues={company?.purchaseOrderSettings}
          onValuesChange={(_, values) => updateSettings(values)}
        >
          <Form.Item
            name="internalDescriptionVisible"
            label="Show line item internal description on purchase orders"
          >
            <Switch />
          </Form.Item>

          {/* <Form.Item
            name="deliveryNotes"
            label="Default Delivery Notes"
          >
            <Input.TextArea
              placeholder="Enter any default delivery notes or instructions"
              rows={3}
            />
          </Form.Item> */}
        </Form>
      </Card>
    </div>
  );
};